import { WEBSOCKET_MESSAGE_NAME } from "@/constants";
import { useState } from "react";
import { useUser } from "@/context/user-context";
import { useChannel } from "ably/react";
import { ToastType } from "@/enums";
import { displayToast } from "@/utils/toast";
import { DatasetGroup } from "@/queries/datasets/types";
import { useQueryClient } from "@tanstack/react-query";

export const useDatasetCardUploadProgress = (datasetGroup: DatasetGroup) => {
  const [uploadingProgress, setUploadingProgress] = useState({
    progress: 0,
    dataset_id: "",
  });

  const { user } = useUser();
  const queryClient = useQueryClient();

  useChannel(
    `user:${user.id}`,
    WEBSOCKET_MESSAGE_NAME.DATASET_FILE_PROCESSING_PROGRESS,
    (data) => {
      const { dataset_id, payload } = JSON.parse(data.data);

      if (datasetGroup.datasets?.find((d) => d.id === Number(dataset_id))) {
        const type = payload.type;
        const processingProgress = Math.round(payload.progress * 0.3);
        const totalProgress =
          type === "file_upload" ? 70 + processingProgress : payload.progress;

        setUploadingProgress({
          progress: totalProgress,
          dataset_id,
        });
      }
    },
  );

  useChannel(
    `user:${user.id}`,
    WEBSOCKET_MESSAGE_NAME.DATASET_FILE_PROCESSING_COMPLETE,
    async (payload) => {
      const { status, dataset_id } = JSON.parse(payload.data);
      const dataset = datasetGroup.datasets?.find(
        (d) => d.id === Number(dataset_id),
      );

      if (!dataset) return;

      setUploadingProgress({
        progress: 0,
        dataset_id,
      });

      if (status === "false") {
        displayToast(
          `Dataset ${datasetGroup.name} processing failed`,
          ToastType.error,
        );
      } else {
        displayToast(
          `Dataset ${datasetGroup.name} processing complete`,
          ToastType.success,
        );
      }

      await queryClient.invalidateQueries(["dataset-groups"]);
    },
  );

  return { uploadingProgress };
};
